import { message } from "antd";
import axios from "axios";
import { getSubdomain } from "./utils";

const url = process.env.REACT_APP_API_BASE_URL;

let isLoggingOut = false;

export const handleLogout = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  message.info("Session has expired. Log in to continue");
  localStorage.clear();
  setTimeout(() => {
    window.location.href = "/#/login";
  }, 500);
};

const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const subdomain = getSubdomain();
    let dynamicBaseURL;

    if (subdomain === "bovepay") {
      dynamicBaseURL = process.env.REACT_APP_API_BASE_URL_BOVEPAY;
    } else if (subdomain === "ndovupay" || subdomain === "localhost") {
      dynamicBaseURL = process.env.REACT_APP_API_BASE_URL_NDOVUPAY;
    } else {
      dynamicBaseURL = process.env.REACT_APP_API_BASE_URL;
    }

    config.baseURL = dynamicBaseURL;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response ? error.response.status : null;

    if (statusCode == 403) {
      handleLogout();
    }

    if (statusCode == 401) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
